import React from 'react'
const Coaching = () => {
return <div>
'Coaching: Coming Soon'
</div>
}
export default Coaching